import { ConsignmentTabFields, HeaderTabFields } from '../types/fieldEnums';
import { LicenseTypeNature } from '../../../types';

export function getHeaderTabFields(licenseTypeNature?: LicenseTypeNature) {
  return licenseTypeNature === LicenseTypeNature.EPHYTO
    ? { ...HeaderTabFields, countryOfDestinationCode: undefined }
    : HeaderTabFields;
}

export function getConsignmentTabFields() {
  return {
    ...ConsignmentTabFields,
    countryOfDestinationCode: HeaderTabFields.countryOfDestinationCode,
  };
}
